/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";

// Images
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";

export default function data() {
  const Author = ({ image, name, email }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDAvatar src={image} name={name} size="sm" />
      <MDBox ml={2} lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name}
        </MDTypography>
        <MDTypography variant="caption">{email}</MDTypography>
      </MDBox>
    </MDBox>
  );

  const Job = ({ title, description }) => (
    <MDBox lineHeight={1} textAlign="left">
      <MDTypography display="block" variant="caption" color="text" fontWeight="medium">
        {title}
      </MDTypography>
      <MDTypography variant="caption">{description}</MDTypography>
    </MDBox>
  );

  return {
    columns: [
      { Header: "Player", accessor: "author", width: "45%", align: "left" },
      { Header: "Goals", accessor: "function", align: "left" },
      { Header: "Assists", accessor: "employed", align: "center" },
      { Header: "action", accessor: "action", align: "center" },
      { Header: "Status", accessor: "status", align: "center" },
    ],

    rows: [
      {
        author: <Author image="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSv_vkodeCh-nreZwCzR3EMzTdDq-yXH1R62IwGdURZeQ&s" name="Kylian Mbappé" email="Paris Saint-Germain F.C." />,
        function: <Job title="18"/>,
        status: (
          <MDBox ml={-1}>
            <MDBadge badgeContent="ACTIVE" color="success" variant="gradient" size="sm" />
          </MDBox>
        ),
        employed: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            3
          </MDTypography>
        ),
        action: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            Edit
          </MDTypography>
        ),
      },
      {
        author: <Author image="https://i.pinimg.com/564x/3f/31/2e/3f312e60c677c94f903067a9c0912729.jpg" name="Harry Kane" email="FC Bayern Munich" />,
        function: <Job title="17"/>,
        status: (
          <MDBox ml={-1}>
            <MDBadge badgeContent="ACTIVE" color="success" variant="gradient" size="sm" />
          </MDBox>
        ),
        employed: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            4
          </MDTypography>
        ),
        action: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            Edit
          </MDTypography>
        ),
      },
      {
        author: <Author image="https://i.pinimg.com/564x/df/69/9a/df699ab04258330f1aafbe1d6f7cc0ea.jpg" name="Erling Haaland" email="Manchester City FC" />,
        function: <Job title="16"/>,
        status: (
          <MDBox ml={-1}>
            <MDBadge badgeContent="INJURED" color="error" variant="gradient" size="sm" />
          </MDBox>
        ),
        employed: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            1
          </MDTypography>
        ),
        action: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            Edit
          </MDTypography>
        ),
      },
      {
        author: <Author image="https://i.pinimg.com/736x/0a/cb/e5/0acbe508d9e5811ac8ee5d9ba6011ece.jpg" name="Vinicius Junior" email="Real Madrid CF" />,
        function: <Job title="12"/>,
        status: (
          <MDBox ml={-1}>
            <MDBadge badgeContent="ACTIVE" color="success" variant="gradient" size="sm" />
          </MDBox>
        ),
        employed: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            9
          </MDTypography>
        ),
        action: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            Edit
          </MDTypography>
        ),
      },
      {
        author: <Author image="https://i.pinimg.com/736x/4e/83/4e/4e834e499319dd6bb4c7e317ed0e56d3.jpg" name="Jude Bellingham" email="Real Madrid CF" />,
        function: <Job title="9" />,
        status: (
          <MDBox ml={-1}>
            <MDBadge badgeContent="ACTIVE" color="success" variant="gradient" size="sm" />
          </MDBox>
        ),
        employed: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            4
          </MDTypography>
        ),
        action: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            Edit
          </MDTypography>
        ),
      },
      {
        author: <Author image="https://i.pinimg.com/736x/bf/4f/8a/bf4f8a3a9f5a7e7add1197c2d858e403.jpg" name="Phil Foden" email="Manchester City FC" />,
        function: <Job title="7"/>,
        status: (
          <MDBox ml={-1}>
            <MDBadge badgeContent="INJURED" color="error" variant="gradient" size="sm" />
          </MDBox>
        ),
        employed: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            2
          </MDTypography>
        ),
        action: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            Edit
          </MDTypography>
        ),
      },
    ],
  };
}
